"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.notificationRegistry = exports.NotificationRegistry = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var NotificationRegistry = /*#__PURE__*/function () {
  function NotificationRegistry() {
    (0, _classCallCheck2.default)(this, NotificationRegistry);
    this.notificationHandlers = [];
  }

  (0, _createClass2.default)(NotificationRegistry, [{
    key: "addProvider",

    /**
     * Adds a reducer that will get the current notification
     *
     * @description Note: This API is subject to change once the notification center is built
     *
     * @param reducer
     */
    value: function addProvider(reducer) {
      this.notificationHandlers.push(reducer);
    }
    /**
     * @internal
     */

  }, {
    key: "getProviders",
    value: function getProviders() {
      return this.notificationHandlers;
    }
    /**
     * @internal
     */

  }, {
    key: "getNotifications",
    value: function getNotifications(state) {
      var _context;

      return (0, _reduce.default)(_context = this.notificationHandlers).call(_context, function (currentState, handler) {
        var notification = handler(state);

        if (!currentState) {
          currentState = notification;
        }

        return currentState;
      }, undefined);
    }
  }]);
  return NotificationRegistry;
}();

exports.NotificationRegistry = NotificationRegistry;
var notificationRegistry = new NotificationRegistry();
exports.notificationRegistry = notificationRegistry;